export const eventNames = {
    PAGE_VIEW: 'page-view',
    VIEWED_PRODUCT: 'viewed-product',
    ADD_TO_CART: 'add-to-cart',
    REMOVE_FROM_CART: 'remove-from-cart',
    UPDATE_CART: 'update-cart',
    DISCOUNT_CODE_UPDATED: 'discount-code-updated',
    PERFORMANCE: 'performance',
};
